import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

function Header() {
  return (
    <header className="site-header">
      <a className="brand" href="#top" aria-label="AI Essay Help home">
        <span className="brand-mark">
          <SafeIcon icon={FiMessageCircle} aria-hidden="true" />
        </span>
        <span className="brand-name">The Family Conversation</span>
      </a>
      <nav className="header-nav" aria-label="Main navigation">
        <a href="#how-it-works">How it works</a>
        <a href="#what-youll-practice">What you’ll practice</a>
        <a className="header-cta" href="#session">
          Start practice
          <span aria-hidden="true">↗</span>
        </a>
      </nav>
    </header>
  );
}

export default Header;
